module.exports = __webpack_public_path__ + "img/6.01dad3da.png";